module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Speedy Zizzi - Order At Table","short_name":"Speedy Zizzi","icon":"static/images/Speedy-Order-Logo-S.png","icons":[{"src":"static/images/Speedy-Order-Logo-S.png","sizes":"192x192","type":"image/png"},{"src":"static/images/Speedy-Order-Logo-L.png","sizes":"512x512","type":"image/png"}],"start_url":"/?utm_source=web_app_manifest","display":"standalone","orientation":"natural","background_color":"#FEF9EC","theme_color":"#263D4B","dir":"ltr","lang":"en-GB","scope":"/","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"05d6a4de95d3b581953e6e0eff887aab"},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-smoothscroll/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-async/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
